
import { defineComponent, PropType, ref, watch, nextTick, computed } from 'vue'

import { renderQrCode } from '@/utils/qrcode'
import { getStarPurchaseQrUrl } from '@/utils/useStarTip'
import type { StarUnlockState } from '@/utils/useStarTip'

export default defineComponent({
  name: 'StarTipDialog',
  props: {
    tipDialog: { type: Object as PropType<any>, required: true },
    unlock: { type: Object as PropType<StarUnlockState>, required: true },
  },
  emits: ['unlock-close', 'unlock-banner-click', 'unlock-share-close', 'unlock-promo-close', 'unlock-purchase-click'],
  setup(props, { emit }) {
    const purchaseQrRef = ref<HTMLElement | null>(null)

    const thumbnailImageUrl = computed(() => props.unlock.activity?.image || '')
    const promoImageUrl = computed(() => props.unlock.activity?.detailImage || '')

    const onClose = () => emit('unlock-close')
    const onBannerClick = () => emit('unlock-banner-click')
    const onShareClose = () => emit('unlock-share-close')
    const onPromoClose = () => emit('unlock-promo-close')
    const onPurchaseClick = () => emit('unlock-purchase-click')

    watch(
      () => props.unlock.showPurchase,
      async (val) => {
        if (!val) return
        await nextTick()
        if (purchaseQrRef.value) {
          renderQrCode(purchaseQrRef.value, getStarPurchaseQrUrl(), 160)
        }
      }
    )

    return {
      purchaseQrRef,
      thumbnailImageUrl,
      promoImageUrl,
      onClose,
      onBannerClick,
      onShareClose,
      onPromoClose,
      onPurchaseClick,
    }
  }
})
